import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import * as Colors from 'ui-library/Colors';

import {EditComponentButton, RemoveComponentButton} from './RunSchemaEditorActionButton';

interface EditableConfigOptionDisplayProps {
  disabled?: boolean;
  onEdit: () => void;
  onRemove: () => void;
  editButtonLabel: string;
  removeButtonLabel: string;
  dataTestAttrs?: DataTestAttrs;
  editTestAttrs?: DataTestAttrs;
  removeTestAttrs?: DataTestAttrs;

  children: React.ReactNode;
}

export default function EditableConfigOptionDisplay(props: EditableConfigOptionDisplayProps): JSX.Element {
  const [hideActionButtons, setHideActionButtons] = useState(true);

  return (
    <div
      onMouseEnter={() => {
        setHideActionButtons(false);
      }}
      onMouseLeave={() => {
        setHideActionButtons(true);
      }}
      className={css(styles.outerContainer, !hideActionButtons ? styles.active : null)}
    >
      <div className={css(styles.innerContainer)} {...getTestProps(props.dataTestAttrs)}>
        {props.children}
      </div>
      <div className={css(styles.actionButtons, hideActionButtons ? styles.hidden : null)}>
        {!props.disabled && (
          <>
            <RemoveComponentButton
              label={props.removeButtonLabel}
              onClick={props.onRemove}
              dataTestAttrs={props.removeTestAttrs}
            />
            <EditComponentButton
              label={props.editButtonLabel}
              onClick={props.onEdit}
              dataTestAttrs={props.editTestAttrs}
            />
          </>
        )}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  actionButtons: {
    display: 'flex',
    flex: 0.2,
    justifyContent: 'flex-end',
    marginTop: '4px',
  },
  outerContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginLeft: '-8px',
    alignItems: 'flex-start',
  },
  innerContainer: {
    wordWrap: 'break-word',
    overflowWrap: 'anywhere',
    paddingLeft: '8px',
    paddingTop: '6px',
    paddingBottom: '6px',
    flex: 0.8,
  },
  active: {
    background: Colors.GRAY_LIGHTER,
  },
  hidden: {
    display: 'none',
  },
});
